import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const UserProfileClientForConfluenceQuery: GraphQLTaggedNode = graphql`
	query UserProfileClientForConfluenceQuery($userId: ID) {
		user: confluence_atlassianUser(current: false, id: $userId) {
			id
			confluence {
				permissionType
			}
		}
		entitlements {
			externalCollaborator {
				isEntitled
			}
		}
	}
`;
